import { Edit, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Switch, Select, InputNumber, Button } from "antd";
import { useTranslate } from "@refinedev/core";
import { useEffect } from "react";

export const PricingPlanEdit = () => {
  const { formProps, saveButtonProps, queryResult } = useForm();
  const _t = useTranslate();

  const { selectProps: productSelectProps } = useSelect({
    resource: "products",
    optionLabel: "name",
    optionValue: "id",
  });

  const validateDuplicateProduct =
    (fieldIndex: number) => (_: any, value: any) => {
      if (!value) {
        return Promise.resolve();
      }
      const products = formProps.form?.getFieldValue("products") || [];
      const duplicateCount = products.filter(
        (product: any, index: number) =>
          product?.productId === value && index !== fieldIndex,
      ).length;
      if (duplicateCount > 0) {
        return Promise.reject(
          new Error(_t("pricing-plans.errors.duplicateProduct")),
        );
      }
      return Promise.resolve();
    };

  // Transform pricingPlanProducts into the format expected by the form
  useEffect(() => {
    const pricingPlanProducts = queryResult?.data?.data?.pricingPlanProducts;
    if (pricingPlanProducts) {
      const products = pricingPlanProducts.map((item: any) => ({
        productId: item.product.id,
        customPrice: item.price,
      }));
      formProps.form?.setFieldsValue({ products });
    }
  }, [queryResult?.data?.data?.pricingPlanProducts]);

  return (
    <div className="max-w-7xl mx-auto">
      <Edit saveButtonProps={saveButtonProps}>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label={_t("pricing-plans.fields.name")}
            name="name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={_t("pricing-plans.fields.description")}
            name="description"
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label={_t("pricing-plans.fields.isActive")}
            name="isActive"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
          <div className="max-w-[900px]">
            <Form.List name="products">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <div key={key} className="flex gap-2">
                      <Form.Item
                        {...restField}
                        name={[name, "productId"]}
                        rules={[
                          {
                            required: true,
                            message: _t("fields.errors.required"),
                          },
                          { validator: validateDuplicateProduct(name) },
                        ]}
                        className="w-full"
                      >
                        <Select {...productSelectProps} />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, "customPrice"]}>
                        <InputNumber
                          placeholder={_t("pricing-plans.fields.customPrice")}
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                      <Button onClick={() => remove(name)} type="link">
                        {_t("buttons.delete")}
                      </Button>
                    </div>
                  ))}
                  <Form.Item>
                    <Button type="primary" onClick={() => add()} block>
                      {_t("pricing-plans.actions.addProduct")}
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
        </Form>
      </Edit>
    </div>
  );
};
